var _this = this;

import handlebars from 'handlebars';
import { Parser, ProcessNodeDefinitions } from 'html-to-react';
import React from 'react';
import { VideoPlayer } from '../subkit-ui';
import { AudioPlayer } from '../subkit-ui/basic/AudioPlayer';
import { jsx as _jsx } from "react/jsx-runtime";
export var parseHTMLTemplate = function parseHTMLTemplate(html, context, errorCallback) {
  try {
    // set strict option to true to enable handlebars to throw an error
    // if a variable is missing
    var template = handlebars.compile(html, {
      strict: true
    });
    var compiledHtml = template(context);
    return parseHTML( // convert template tags to div so the markup will be rendered
    compiledHtml.replace(/<(\/?)template/g, function (match) {
      return "".concat(match[0], "div");
    }));
  } catch (error) {
    if (errorCallback) {
      errorCallback.call(_this, error);
    } // return the uncompiled template so markup will be rendered


    return parseHTML(html);
  }
};
export var parseHTML = function parseHTML(html) {
  var parser = new Parser();

  var isValidNode = function isValidNode() {
    return true;
  };

  var processNodeDefinitions = new ProcessNodeDefinitions(React);
  var processingInstructions = [// Swap out the video element for the VideoPlayer component
  {
    shouldProcessNode: function shouldProcessNode(node) {
      return node.name === 'audio' || node.name === 'video';
    },
    processNode: function processNode(node, children, index) {
      switch (node.name) {
        case 'video':
          {
            var src = node.attribs['src'];
            var poster = node.attribs['poster'];
            return /*#__PURE__*/_jsx(VideoPlayer, {
              className: "my-1-125 mx-auto",
              src: src,
              poster: poster,
              children: children
            }, index);
          }

        case 'audio':
          {
            var _src = node.attribs['src'];
            return /*#__PURE__*/_jsx(AudioPlayer, {
              className: "my-1-125 mx-auto",
              src: _src,
              children: children
            }, index);
          }
      }
    }
  }, {
    // Anything else
    shouldProcessNode: function shouldProcessNode() {
      return true;
    },
    processNode: processNodeDefinitions.processDefaultNode
  }];
  return parser.parseWithInstructions(html, isValidNode, processingInstructions);
};